<div class="container" #container *ngIf="!isLoading">
    <div class="header">
        <div class="title">
            {{ 'integration.trigger-condition.dialog.title' | translate }}
        </div>
        <mat-icon class="icon" svgIcon="close" (click)="close(undefined)"></mat-icon>
    </div>
    <div class="main">
        <div class="conditon-container none-condition" *ngIf="!elementConditionList.length">
            <div class="none-conditon-text">
                {{ 'integration.trigger-condition.dialog.no-data.text' | translate }}
            </div>
            <div class="select-button" (click)="openMatrixDialog()">
                {{ 'integration.trigger-condition.dialog.add-condition.button-text' | translate }}
            </div>
        </div>

        <div class="conditon-container" *ngIf="elementConditionList.length">
            <div
                class="condition-item"
                *ngFor="let condition of elementConditionList; let i = index"
                (click)="selectElementCondition(condition); $event.stopPropagation()">
                <div class="condition-name">{{ condition.name }}</div>
                <mat-icon
                    class="help-icon"
                    svgIcon="info"
                    [class.selected]="condition.index === selectedElementCondition?.index"
                    (click)="openConditionLogicDialog(condition); $event.stopPropagation()"></mat-icon>
            </div>
        </div>
    </div>
</div>

<app-loading-spinner
    *ngIf="isLoading"
    class="spinner-component"
    [custom]="true"
    size="80"
    strokeWidth="3"></app-loading-spinner>
